const CATEGORY_RE = /\/categories\/(\d+)(?:-[^/]*)?/
const SECTION_RE = /\/sections\/(\d+)(?:-[^/]*)?/
const ARTICLE_RE = /\/articles\/(\d+)(?:-[^/]*)?/

export function matchInternalRoute(pathname) {
  const category = pathname.match(CATEGORY_RE)
  if (category) return { kind: 'category', id: category[1] }

  const section = pathname.match(SECTION_RE)
  if (section) return { kind: 'section', id: section[1] }

  const article = pathname.match(ARTICLE_RE)
  if (article) return { kind: 'article', id: article[1] }

  return null
}

export function toRouteLocation(match, context = {}) {
  if (!match) return null

  if (match.kind === 'category') {
    return { name: 'CategoryDetails', params: { categoryId: match.id } }
  }

  if (match.kind === 'section') {
    return { name: 'Section', params: { sectionId: match.id } }
  }

  if (match.kind === 'article') {
    return {
      name: 'Article',
      params: {
        categoryId: context.categoryId,
        sectionId: context.sectionId,
        articleId: match.id
      }
    }
  }

  return null
}
